const Ajax = (function () {
  function request(opt) {
    function fn() {
    }
    let url = opt.url || ''
    const async = opt.async !== false; let method = opt.method || 'GET'; let data = opt.data
              || null; const success = opt.success || fn; const error = opt.failure
              || fn
    method = method.toUpperCase()
    //        if (method == 'GET' && data) {
    const fm = new FormData()
    if (data) {
      let args = ''
      if (typeof data == 'string') {
        // alert("string")
        args = data
      }
      else if (typeof data == 'object') {
        // alert("object")
        const arr = []
        if (method == 'GET') {
          for (var k in data) {
            var v = data[k]
            arr.push(`${k}=${v}`)
          }
          args = arr.join('&')
        }
        else if (method == 'POST') {
          for (var k in data) {
            var v = data[k]
            fm.append(k, v)
          }
        }
      }
      url += (!url.includes('?') ? '?' : '&') + args
      data = null
    }
    const xhr = window.XMLHttpRequest
      ? new XMLHttpRequest()
      : new ActiveXObject('Microsoft.XMLHTTP')
    xhr.onreadystatechange = function () {
      _onStateChange(xhr, success, error)
    }
    if (method == 'GET') {
      xhr.open(method, url, async)
      xhr.send(data)
    }
    else if (method == 'POST') {
      xhr.open(method, opt.url, async)
      xhr.send(fm)
    }
    //        if (method == 'POST') {
    //            xhr.setRequestHeader('Content-type',
    //                    'application/x-www-form-urlencoded;');
    //        }
    //        xhr.send(data);
    return xhr
  }
  function _onStateChange(xhr, success, failure) {
    if (xhr.readyState == 4) {
      const s = xhr.status
      if (s >= 200 && s < 300)
        success(xhr)
      else
        failure(xhr)
    }
    else {
    }
  }
  return {
    request,
  }
}())
function sleep(time) {
  const startTime = new Date().getTime() + parseInt(time, 10)
  while (new Date().getTime() < startTime) {}
}
/**
* SignMessenger.js
* @param the tag id
* @author kevin 20160923
* @return control obj
*/
function SignMessenger(id) {
  let serurl = '/mchgateway/sdpsecurity/mch/ca/execute'
  const channelid = '003'
  const strsubject = 'countryName,CN;organizationName,microdone;organizationalUnitName,YFB;'
  const email = 'test1@163.com'
  const factor1 = 20000
  const factor2 = 5
  const onemb = (0.000244140625 / 32)
  const timecostfactor = 0.001
  const sm4key = '1234567890123456'
  const iv = '1234567890123456'
  const getRandomjson = { functionid: 'getRandom', parameters: [{ randomLen: 0 }] }
  //	var genKeyPairres=false;
  //	var csrpin="";
  const initContrjson = { functionid: 'initContr', parameters: [{ userId: 'xxxx' }] }
  const genSerKeyjson = { functionid: 'genSerKey', parameters: [{ pin: '' }, { channel: channelid }] }
  const genSerKeyEncjson = { functionid: 'genSerKeyEnc', parameters: [{ pin: '' }, { channel: channelid }] }
  const genClnKeyjson = { functionid: 'genClnKey', parameters: [{ pin: '' }, { servdata: '' }] }
  const genClnKeyEncjson = { functionid: 'genClnKeyEnc', parameters: [{ pin: '' }, { servdata: '' }] }
  const genRAWCSRjson = { functionid: 'genRAWCSR', parameters: [{ pin: '' }, { subject: '' }] }
  const preSignjson = { functionid: 'preSign', parameters: [{ pin: '' }, { msg: '' }] }
  const serverSignjson = { functionid: 'serverSign', parameters: [{ pin: '' }, { channel: channelid }, { q1: '' }, { e: '' }] }
  const fullSignjson = { functionid: 'fullSign', parameters: [{ pin: '' }, { rd: '' }, { msg: '' }, { type: 1 }] }
  const fullSign4SFTjson = { functionid: 'fullSign4SFT', parameters: [{ pin: '' }, { rd: '' }, { msg: '' }, { type: 1 }, { channel: channelid }] }
  const genFULLCSRjson = { functionid: 'genFULLCSR', parameters: [{ pin: '' }, { subject: '' }, { signed: '' }] }
  const servDownCertjson = { functionid: 'serverDownCert', parameters: [{ channel: channelid }, { email }, { csr: '' }] }
  // var decryptCertjson={"functionid":"decryptCert","parameters":[{"cert":""}]};
  const decryptServerDatajson = { functionid: 'decryptServerData', parameters: [{ cert: '' }, { flag: true }] }
  const verifyjson = { functionid: 'verify', parameters: [{ signed: '' }, { src: '' }] }
  const encryptjson = { functionid: 'encrypt', parameters: [{ src: '' }] }
  const serverVerify = { functionid: 'serverVerify', parameters: [{ src: '' }, { channel: channelid }] }
  //	var encryptencjson={"functionid":"encryptenc","parameters":[{"src":""}]};
  const clnDecryptjson = { functionid: 'clnDecrypt', parameters: [{ pin: '' }, { cipher: '' }] }
  //	var clnDecryptEncjson={"functionid":"clnDecryptEnc","parameters":[{"pin":""}, {"cipher":""}]};
  const servDecryptjson = { functionid: 'servDecrypt', parameters: [{ pin: '' }, { channel: channelid }, { c1: '' }] }
  //	var servDecryptEncjson={"functionid":"servDecryptEnc","parameters":[{"pin":""}, {"channel":channelid}, {"c1":""}]};
  const fullDecryptjson = { functionid: 'fullDecrypt', parameters: [{ pin: '' }, { rdata: '' }, { cipher: '' }] }
  //	var fullDecryptEncjson={"functionid":"fullDecryptEnc","parameters":[{"pin":""}, {"rdata":""}, {"cipher":""}]};
  const getLibVersionjson = { functionid: 'getLibVersion' }
  const getMacAddressjson = { functionid: 'getMacAddress' }
  // 20240417
  const getSerialNojson = { functionid: 'getSerialNo' }
  const verifypinjson = { functionid: 'verifypin', parameters: [{ pin: '' }] }
  const modifyclnpinjson = { functionid: 'modifyclnpin', parameters: [{ pin: '' }, { newpin: '' }] }
  const modifyserpinjson = { functionid: 'modifyserpin', parameters: [{ pin: '' }, { newpin: '' }, { channel: channelid }] }
  const decryptServerDatajson2 = { functionid: 'decryptServerData', parameters: [{ data: '' }, { flag: false }] }
  const deletecontainerjson = { functionid: 'deletecontainer' }
  const SM4Encrytjson = { functionid: 'SM4Encryt', parameters: [{ mode: '' }, { iv: '' }, { plain: '' }, { key: '' }] }
  const SM4Decrytjson = { functionid: 'SM4Decryt', parameters: [{ mode: '' }, { iv: '' }, { chiper: '' }, { key: '' }] }
  const SM3Digestjson = { functionid: 'SM3Digest', parameters: [{ pSrc: '' }] }
  const importSignCert = { functionid: 'impCert', parameters: [{ cert: '' }, { channel: channelid }] }
  const importEncCert = { functionid: 'impEncCert', parameters: [{ cert: '' }] }
  const certificateQueryjson = { functionid: 'certificateQuery', parameters: [{ channel: channelid }] }
  const certificateRevocation = { functionid: 'certificateRevocation', parameters: [{ channel: channelid }] }
  const provjson = { pcode: 0, type: 0, name: 'citic_ukey' }// result {"ecode":0, "message":""，"pid":0}
  let cname = ''
  const invokjson = { pcode: 1, type: 0, pid: 0, params: 'eyJmdW5jdGlvbmlkIjoiSW5pdGlhbGl6ZSIsInBhcmFtZXRlcnMiOlt7InZlbmRvciI6InRkciJ9XX0KCQkJCQk=' }
  // result {"ecode":0, "message":"","pid":0, "returnvalue":"eyJyZXR1cm52YWx1ZSI6W3sidmFsdWUiOiJhYWEifSx7InZhbHVlIjo0NTZ9XX0="}
  const removejson = { pcode: 2, pid: 0 }	// result {"ecode":0, "message":""}
  const provlistjson = { pcode: 3, type: 0 }// result {"ecode":0, "message":"", "list":["XXX1", "XXX2"]}
  const versionjson = { pcode: 4 }// result {"ecode":0, "message":"", "version":"1.0.0.0"}
  const openlogjson = { pcode: 7, Log: true }
  const closelogjson = { pcode: 7, Log: false }
  const logstatusjson = { pcode: 8 }
  const errjson = { pcode: 5, errcode: 0 }// result {"ecode":0, "message":"", "errormessage":"操作成功"}
  const licensejson = { pcode: 6, licensecode: 'VjdNK2ViNWE0T2xBVDQxOWNsckZtUW9kdlVKMnh2dU5Jd08wRHBYQitBWW15aitUSGMybGtndFNVRXBWR0JVcnJ6cUdBM2JBelU4ZXVSWEhJUCt5R01iVjlhU2VTNEIvK2JjOWRNUEtCTVdvbzllQ3dtYVQwTnhvQlpqK0N3QjRJQ29hYnhlRExXSmRYSllXQU81UmlpeHRnQXBGRHZQMU1aWmFubUxtRStrPXsiaWQiOjEsInR5cGUiOiJwcm9kdWN0IiwicGFja2FnZSI6WyIiXSwiYXBwbHluYW1lIjpbIiplY2l0aWMuY29tIiwiKmNpdGljYmFuay5jbiIsIipjaXRpY2JhbmsuY2l0aWMiLCIyMDIuOTkuMjIuMjI0Il0sInBsYXRmb3JtIjo0fQ==' }
  // result {"ecode":0, "message":""}
  this.signWindowID = `signmessenger${new Date().getTime()}`
  const objj = this
  this.curpid = 0
  this.cutlen = 500000
  this.wqinterv = 1
  this.tdrinterv = 1
  this.ftinterv = 1
  this.ft2Ginterv = 1
  this.wqfirstflag = 0
  this.tdrfirstflag = 0
  this.ftfirstflag = 0
  this.ft2Gfirstflag = 0
  // the js version
  this.sdkVersion = '1.0.0.1'
  let url = 'https://127.0.0.1'
  const port = 6776; const lastPort = port + 4; let urls = `${url}:${port}`
  this.hasMacUKey = false
  const sid = this.signWindowID
  const ua = navigator.userAgent.toLowerCase()
  // check chrome
  let chr = ''; const regStr_chrome = /chrome\/[\d.]+/gi
  const regStr_firefox = /firefox\/[\d.]+/gi
  if (navigator.platform == 'Win64' && navigator.userAgent.includes('Firefox'))
    chr = 'chromeh'
  if (ua.indexOf('chrome') > 0) {
    let chromeVersion = ua.match(regStr_chrome).toString()
    chromeVersion = parseInt(chromeVersion.replace(/[^0-9.]/gi, ''))
    if (chromeVersion >= 42)
      chr = 'chromeh'
    else
      chr = 'chromel'
  }
  else {
    if (ua.indexOf('safari') > 0) {
      const regStr_mac = /Version\/[\d.]+/gi
      let num = navigator.userAgent.match(regStr_mac).toString()
      num = parseInt(num.replace(/[^0-9.]/gi, ''))
      if (num >= 12)
        chr = 'chromeh'
      else
        chr = 'chromel'
    }
  }
  if (ua.indexOf('firefox') > 0) {
    let firefoxVersion = navigator.userAgent.match(regStr_firefox).toString()
    firefoxVersion = parseInt(firefoxVersion.replace(/[^0-9.]/gi, ''))
    if (firefoxVersion >= 50)
      chr = 'chromeh'
    else
      chr = 'chromel'
    //		this.cutlen=1000000;
  }
  if (ua.indexOf('edge') > 0)
    chr = 'chromeh'
  // check OS & browser
  this.env = {
    isWindows: (ua.includes('windows') || ua.includes('win32')),
    isMac: (ua.includes('macintosh') || ua.includes('mac os x')),
    isLinux: (ua.includes('linux')),
    ie: (ua.includes('msie') || ua.includes('trident')),
    firefox: ua.includes('firefox'),
    chrome: ua.includes('chrome'),
    opera: ua.includes('opera'),
    safari: ua.includes('version'),
    edge: ua.includes('edge') || chr.includes('chromeh'),
  }
  if (this.env.isMac)
    url = 'https://127.0.0.1'
  this.checkOsBrowser = function () {
    if (chr == 'chromeh')
      return true
    else
      return false
  }
  //	this.sm3 = function(msg){
  //		var license = "";
  //		window.mg = new messageguard(license);
  //		window.onload = function() {}
  //		var ret = mg.GenerateTheSM3ForData(0, msg);
  //		if (ret.code == "0") {
  //			return ret.SM3;
  //		} else {
  //			return "code:" + ret.code + " " + "message:" + ret.message;
  //		}
  //	}
  // 发同步ajax请求
  this.pwdGetData = function (datas) {
    let d = 0
    const obj = this
    const str = JSON.stringify(datas).replace(/\+/g, '%2B')
    const cutlen = obj.cutlen
    const strlen = str.length
    if (strlen > cutlen) {
      const cutsize = Math.ceil(strlen / cutlen)
      const spliceid = `${new Date().getTime()}${parseInt(Math.random() * 1000000)}`
      for (let i = 1; i <= cutsize; i++) {
        let splicenum = i
        let cutstr = ''
        if (i == cutsize) {
          splicenum = -1
          cutstr = str.substring((i - 1) * cutlen)
        }
        else {
          cutstr = str.substring((i - 1) * cutlen, i * cutlen)
        }
        Ajax.request({
          timeout: 0,
          url: urls,
          type: 'GET',
          method: 'GET',
          async: false,
          data: {
            enctype: 'multipart/form-data',
            jsoncallback: 'cb',
            str: cutstr,
            times: obj.getTimes(),
            com: 'xxx',
            spliceid,
            splicenum,
          },
          success(x) {
            x = x.responseText.substr('cb('.length)
            x = x.substring(0, x.length - 1)
            x = JSON.parse(x)
            d = x
          },
          error(x) {
            d = -1
          },
        })
      }
    }
    else {
      Ajax.request({
        timeout: 0,
        url: urls,
        type: 'GET',
        method: 'GET',
        async: false,
        data: {
          enctype: 'multipart/form-data',
          jsoncallback: 'cb',
          str,
          times: obj.getTimes(),
          com: 'xxx',
        },
        success(x) {
          x = x.responseText.substr('cb('.length)
          x = x.substring(0, x.length - 1)
          x = JSON.parse(x)
          d = x
        },
        error(x) {
          d = -1
        },
      })
    }
    return d
  }
  this.pwdGetDataYB = function (datas, callf) {
    const jsonp = window.jsonp || window.parent.jsonp
    const d = 0
    const obj = this
    const str = JSON.stringify(datas).replace(/\+/g, '%2B')
    const cutlen = obj.cutlen
    const strlen = str.length
    if (strlen > cutlen) {
      const cutsize = Math.ceil(strlen / cutlen)
      const spliceid = `${new Date().getTime()}${parseInt(Math.random() * 1000000)}`
      for (let i = 1; i <= cutsize; i++) {
        let splicenum = i
        let cutstr = ''
        if (i == cutsize) {
          splicenum = -1
          cutstr = str.substring((i - 1) * cutlen)
        }
        else {
          cutstr = str.substring((i - 1) * cutlen, i * cutlen)
        }
        jsonp({
          url: urls,
          data: {
            str: cutstr,
            jsoncallback: 'cb',
            times: obj.getTimes(),
            com: 'xxx',
            spliceid,
            splicenum,
          },
          callback: 'jsoncallback',
          success(x) {
            // x = x.responseText.substr("cb(".length);
          // x = x.substring(0, x.length-1);
          // x = JSON.parse(x);
            if (callf)
              callf(x)
          },
          fail() {
            if (callf)
              callf(false)
          },
        })
      }
    }
    else {
      jsonp({
        url: urls,
        data: {
          str,
          jsoncallback: 'cb',
          times: obj.getTimes(),
          com: 'xxx',
        },
        callback: 'jsoncallback',
        success(x) {
        // x = x.responseText.substr("cb(".length);
        // x = x.substring(0, x.length-1);
        // x = JSON.parse(x);
          if (callf)
            callf(x)
        },
        fail() {
          if (callf)
            callf(false)
        },
      })
    }
  }
  this.pwdGetSerData = function (datas) {
    let d = 0
    Ajax.request({
      timeout: 0,
      url: datas,
      type: 'GET',
      method: 'GET',
      async: false,
      //			data : {
      //			"enctype":"multipart/form-data",
      //			"jsoncallback":"cb",
      //			"str" : str,
      //			"times":obj.getTimes(),
      //			"com" : "xxx"
      //		},
      success(x) {
        //			x = x.responseText.substr("cb(".length);
        //			x = x.substring(0, x.length-1);
        //			x = JSON.parse(x);
        //			d = x;
        d = x.responseText
      },
      error(x) {
        d = -1
      },
    })
    return d
  }
  this.pwdGetData33 = function (datas) {
    let d = 0
    const obj = this
    const str = JSON.stringify(datas).replace(/\+/g, '%2B')
    //		var cutlen = obj.cutlen;
    //		if(str.length>cutlen){
    //			var strlen=str.length;
    //			var cutsize=Math.ceil(strlen/cutlen);
    //			var spliceid=new Date().getTime()+""+parseInt(Math.random()*1000000);
    //			for ( var i = 1; i <= cutsize; i++) {
    //				var splicenum=i;
    //				var cutstr="";
    //				if(i==cutsize){
    //					splicenum=-1;
    //					cutstr=str.substring((i-1)*cutlen);
    //				}else{
    //					cutstr=str.substring((i-1)*cutlen,i*cutlen);
    //				}
    //				Ajax.request( {
    //					timeout : 0,
    //					url : urls,
    //					type : 'POST',
    //					async:false,
    //					data : {
    //					"jsoncallback":"cb",
    //					"str" : cutstr,
    //					"times":obj.getTimes(),
    //					"com" : "xxx",
    //					"spliceid" : spliceid,
    //					"splicenum" : splicenum
    //				},
    //				success : function(x) {
    //					x = x.responseText.substr("cb(".length);
    //					x = x.substring(0, x.length-1);
    //					x = JSON.parse(x);
    //					d = x;
    //				},
    //				error : function(x){
    //					d = -1;
    //				}
    //				});
    //			}
    //		}else{
    for (let k = 0; k < 100; k++) {
      Ajax.request({
        timeout: 60000,
        url: urls,
        type: 'POST',
        async: false,
        data: {
          enctype: 'multipart/form-data',
          jsoncallback: 'cb',
          str,
          times: obj.getTimes(),
          com: 'xxx',
        },
        success(x) {
          x = x.responseText.substr('cb('.length)
          x = x.substring(0, x.length - 1)
          x = JSON.parse(x)
          d = x
          sleep(60000)
        },
        error(x) {
          d = -1
        },
      })
    }
    //		}
    return d
  }
  // 发异步ajax请求
  this.pwdGetDataAsync = function (datas, callback) {
    let d = 0
    const obj = this
    const str = JSON.stringify(datas).replace(/\+/g, '%2B')
    const cutlen = obj.cutlen
    const strlen = str.length
    if (strlen > cutlen) {
      const cutsize = Math.ceil(strlen / cutlen)
      const spliceid = `${new Date().getTime()}${parseInt(Math.random() * 1000000)}`
      for (let i = 1; i <= cutsize; i++) {
        let splicenum = i
        let cutstr = ''
        if (i == cutsize) {
          splicenum = -1
          cutstr = str.substring((i - 1) * cutlen)
        }
        else {
          cutstr = str.substring((i - 1) * cutlen, i * cutlen)
        }
        Ajax.request({
          timeout: 0,
          url: urls,
          type: 'GET',
          method: 'GET',
          async: true,
          data: {
            jsoncallback: 'cb',
            str: cutstr,
            times: obj.getTimes(),
            com: 'xxx',
            spliceid,
            splicenum,
          },
          success(x) {
            x = x.responseText.substr('cb('.length)
            x = x.substring(0, x.length - 1)
            x = JSON.parse(x)
            d = x
            if (d.hasOwnProperty('returnvalue') && d.returnvalue != '') {
              const retu = d.returnvalue
              const retub6 = obj.binayUtf8ToString(obj.base64decodearr(retu), 0)
              var rvobj = JSON.parse(retub6).returnvalue
            }
            else {
              var rvobj = [{ ret: d.ecode }, { errormessage: d.message }, { value: '' }]
            }
            if (callback)
              callback(rvobj)
          },
          error(x) {
            d = -1
          },
        })
      }
    }
    else {
      Ajax.request({
        timeout: 0,
        url: urls,
        type: 'GET',
        method: 'GET',
        async: true,
        data: {
          jsoncallback: 'cb',
          str,
          times: obj.getTimes(),
          com: 'xxx',
        },
        success(x) {
          x = x.responseText.substr('cb('.length)
          x = x.substring(0, x.length - 1)
          x = JSON.parse(x)
          d = x
          if (d.hasOwnProperty('returnvalue') && d.returnvalue != '') {
            const retu = d.returnvalue
            const retub6 = obj.binayUtf8ToString(obj.base64decodearr(retu), 0)
            var rvobj = JSON.parse(retub6).returnvalue
          }
          else {
            var rvobj = [{ ret: d.ecode }, { errormessage: d.message }, { value: '' }]
          }
          if (callback)
            callback(rvobj)
        },
        error(x) {
          d = -1
        },
      })
    }
  }
  this.pwdGetData11 = function (datas) {
    let d = 0
    const obj = this
    const str = JSON.stringify(datas).replace(/\+/g, '%2B')
    Ajax.request({
      timeout: 1000,
      url: urls,
      type: 'POST',
      async: false,
      data: {
        enctype: 'multipart/form-data',
        jsoncallback: 'cb',
        str,
        times: obj.getTimes(),
        com: 'xxx',
      },
      success(x) {
        x = x.responseText.substr('cb('.length)
        x = x.substring(0, x.length - 1)
        x = JSON.parse(x)
        d = x
      },
      error(x) {
        d = -1
      },
    })
    return d
  }
  this.trimRight = function (s) {
    if (s == null)
      return ''
    const whitespace = new String(' \t\n\r')
    let str = new String(s)
    if (whitespace.includes(str.charAt(str.length - 1))) {
      let i = str.length - 1
      while (i >= 0 && whitespace.includes(str.charAt(i))) {
        i--
      }
      str = str.substring(0, i + 1)
    }
    return str
  }
  const pgeRZRandNum = 'F4F22F052CB8124F39EACD36D8A32114'
  const pgeRZDataB = 'hwxHsjL6unwsSLqVxOgxt9PRtoNH6XVFD5sed2SXKZw='
  this.getProvider = function (bb, cc) {
    provjson.name = bb
    cname = bb
    provjson.type = cc
    //		var datac = getEnStr(pgeRZRandNum,provjson);
    const datac = this.base64encode(this.utf16to8(this.trimRight(JSON.stringify(provjson))))
    const RZCIJSON = { rankey: pgeRZRandNum, datab: pgeRZDataB, datac }
    try {
      var tmp = this.pwdGetData(RZCIJSON)
    }
    catch (e) {
      console.error('getProvider 外层 error', e)
      for (let pt = port + 1; pt <= lastPort; pt++) {
        urls = `${url}:${pt}`
        try {
          var tmp = this.pwdGetData(RZCIJSON)
          break
        }
        catch (e) {
          console.error('getProvider 循环层 error', e)
          continue
        }
      }
    }
    this.curpid = tmp.pid
    return tmp
  }
  // 异步版本的 getProvider，避免同步 XHR 阻塞 UI 线程
  // 每个端口最多等待 1 秒，总计最多 5 秒（而非原来的 ~40 秒）
  this.getProviderAsync = function (bb, cc) {
    const self = this
    provjson.name = bb
    cname = bb
    provjson.type = cc
    const datac = self.base64encode(self.utf16to8(self.trimRight(JSON.stringify(provjson))))
    const RZCIJSON = { rankey: pgeRZRandNum, datab: pgeRZDataB, datac }
    const str = JSON.stringify(RZCIJSON).replace(/\+/g, '%2B')

    function tryPort(portNum) {
      return new Promise(function (resolve) {
        const currentUrl = url + ':' + portNum
        const args = 'enctype=multipart/form-data&jsoncallback=cb&str=' + str + '&times=' + self.getTimes() + '&com=xxx'
        const requestUrl = currentUrl + '?' + args

        const xhr = new XMLHttpRequest()
        const timeoutId = setTimeout(function () {
          xhr.abort()
          resolve(null)
        }, 1000)

        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4) {
            clearTimeout(timeoutId)
            if (xhr.status >= 200 && xhr.status < 300) {
              try {
                let text = xhr.responseText.substr('cb('.length)
                text = text.substring(0, text.length - 1)
                resolve(JSON.parse(text))
              } catch (e) {
                resolve(null)
              }
            } else {
              resolve(null)
            }
          }
        }
        xhr.onerror = function () {
          clearTimeout(timeoutId)
          resolve(null)
        }

        try {
          xhr.open('GET', requestUrl, true)
          xhr.send(null)
        } catch (e) {
          clearTimeout(timeoutId)
          resolve(null)
        }
      })
    }

    return (async function () {
      for (let pt = port; pt <= lastPort; pt++) {
        const result = await tryPort(pt)
        if (result && result.pid !== undefined) {
          urls = url + ':' + pt
          self.curpid = result.pid
          return result
        }
      }
      return false
    })()
  }
  this.getRandom = function (bb) {
    getRandomjson.parameters[0].randomLen = parseInt(bb)
    let res = this.invokeProviderPub(getRandomjson)
    if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
      const retu = res.returnvalue
      const retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
      const rvobj = JSON.parse(retub6)
      //			strcipherdata = rvobj.returnvalue;
      res = rvobj.returnvalue[2].value
    }
    return res
  }
  this.initContr = function (userId) {
    initContrjson.parameters[0].userId = userId
    const res = this.invokeProviderPub(initContrjson)
    let strcipherdata
    if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
      const retu = res.returnvalue
      const retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
      const rvobj = JSON.parse(retub6)
      //			strcipherdata = rvobj.returnvalue;
      if (rvobj.returnvalue[0].ret === 0)
        return true
      else
        return false
    }
  }
  this.genKeyPair = function (bb) {
    genSerKeyjson.parameters[0].pin = bb
    let res = this.invokeProviderPub(genSerKeyjson)
    let strcipherdata
    if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
      var retu = res.returnvalue
      var retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
      var rvobj = JSON.parse(retub6)
      //			strcipherdata = rvobj.returnvalue;
      strcipherdata = rvobj.returnvalue[2].value
    }
    document.cookie = 'user=yhoon'
    //		var realurl = serurl+"/SM2DecentralizedPrivatekeySignature/SM2Servlet?action=servGenSM2PartPrikey&encryptData="+strcipherdata;
    const realurl = `${serurl}?action=servGenSM2PartPrikey&encryptData=${strcipherdata}&ticket=${window.ticket}` || ''
    const rdata = this.pwdGetSerData(realurl)
    genClnKeyjson.parameters[0].pin = bb
    genClnKeyjson.parameters[1].servdata = rdata
    res = this.invokeProviderPub(genClnKeyjson)
    if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
      var retu = res.returnvalue
      var retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
      var rvobj = JSON.parse(retub6)
      //			strcipherdata = rvobj.returnvalue;
      const rcode = rvobj.returnvalue[0].ret
      if (rcode == 0) {
        //				genKeyPairres=true;
        //				csrpin=bb;
        return true
      }
      else {
        return false
      }
    }
  }
  this.genKeyPairYB = function (bb, callf) {
    genSerKeyjson.parameters[0].pin = bb
    const obj = this
    this.invokeProviderPubYB(genSerKeyjson, (res) => {
      let strcipherdata
      if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
        const retu = res.returnvalue
        const retub6 = obj.binayUtf8ToString(obj.base64decodearr(retu), 0)
        const rvobj = JSON.parse(retub6)
        //			strcipherdata = rvobj.returnvalue;
        strcipherdata = rvobj.returnvalue[2].value
      }
      document.cookie = 'user=yhoon'
      //		var realurl = serurl+"/SM2DecentralizedPrivatekeySignature/SM2Servlet?action=servGenSM2PartPrikey&encryptData="+strcipherdata;
      const realurl = `${serurl}?action=servGenSM2PartPrikey&encryptData=${strcipherdata}&ticket=${window.ticket}` || ''
      const rdata = obj.pwdGetSerData(realurl)
      genClnKeyjson.parameters[0].pin = bb
      genClnKeyjson.parameters[1].servdata = rdata
      obj.invokeProviderPubYB(genClnKeyjson, (res) => {
        if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
          const retu = res.returnvalue
          const retub6 = obj.binayUtf8ToString(obj.base64decodearr(retu), 0)
          const rvobj = JSON.parse(retub6)
          //			strcipherdata = rvobj.returnvalue;
          const rcode = rvobj.returnvalue[0].ret
          if (rcode == 0) {
            //				genKeyPairres=true;
            //				csrpin=bb;
            if (callf)
              callf(true)
          }
          else {
            if (callf)
              callf(false)
          }
        }
      })
    })
  }
  this.genKeyPairEnc = function (bb) {
    genSerKeyEncjson.parameters[0].pin = bb
    let res = this.invokeProviderPub(genSerKeyEncjson)
    let strcipherdata
    if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
      var retu = res.returnvalue
      var retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
      var rvobj = JSON.parse(retub6)
      //			strcipherdata = rvobj.returnvalue;
      strcipherdata = rvobj.returnvalue[2].value
    }
    //		var realurl = serurl+"/SM2DecentralizedPrivatekeySignature/SM2Servlet?action=servGenSM2PartPrikey&encryptData="+strcipherdata;
    document.cookie = 'user=yhoon'
    const realurl = `${serurl}?action=servGenSM2PartPrikey&encryptData=${strcipherdata}&ticket=${window.ticket}` || ''
    rdata = this.pwdGetSerData(realurl)
    genClnKeyEncjson.parameters[0].pin = bb
    genClnKeyEncjson.parameters[1].servdata = rdata
    res = this.invokeProviderPub(genClnKeyEncjson)
    if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
      var retu = res.returnvalue
      var retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
      var rvobj = JSON.parse(retub6)
      //			strcipherdata = rvobj.returnvalue;
      const rcode = rvobj.returnvalue[0].ret
      if (rcode == 0)
        return true
      else
        return false
    }
  }
  this.genCSR = function (bb, CN) {
    //		if(genKeyPairres&&csrpin.length==6){
    //			var bb=csrpin;
    genRAWCSRjson.parameters[0].pin = bb
    genRAWCSRjson.parameters[1].subject = `${strsubject}commonName,${CN};emailAddress,${CN}@163.com`
    let res = this.invokeProviderPub(genRAWCSRjson)
    if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
      var retu = res.returnvalue
      var retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
      var rvobj = JSON.parse(retub6)
      //				strcipherdata = rvobj.returnvalue;
      let rcode = rvobj.returnvalue[0].ret
      if (rcode == 0) {
        const rawcsr = rvobj.returnvalue[2].value
        preSignjson.parameters[0].pin = bb
        preSignjson.parameters[1].msg = rawcsr
        res = this.invokeProviderPub(preSignjson)
        if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
          var retu = res.returnvalue
          var retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
          var rvobj = JSON.parse(retub6)
          //						strcipherdata = rvobj.returnvalue;
          rcode = rvobj.returnvalue[0].ret
          if (rcode != 0)
            return 'pinerr'
          if (rcode == 0) {
            const q1 = rvobj.returnvalue[2].value
            const e = rvobj.returnvalue[3].value
            serverSignjson.parameters[0].pin = bb
            serverSignjson.parameters[2].q1 = q1
            serverSignjson.parameters[3].e = e
            res = this.invokeProviderPub(serverSignjson)
            if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
              var retu = res.returnvalue
              var retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
              var rvobj = JSON.parse(retub6)
              const strcipherdata = rvobj.returnvalue[2].value
              const realurl = `${serurl}?action=servPartSignByThresholdKey&encryptData=${strcipherdata}`
              const rdata = this.pwdGetSerData(realurl)
              fullSignjson.parameters[0].pin = bb
              fullSignjson.parameters[1].rd = rdata
              fullSignjson.parameters[2].msg = ''
              fullSignjson.parameters[3].type = 0
              res = this.invokeProviderPub(fullSignjson)
              if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
                var retu = res.returnvalue
                var retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
                var rvobj = JSON.parse(retub6)
                rcode = rvobj.returnvalue[0].ret
                if (rcode == 0) {
                  const rsigned = rvobj.returnvalue[2].value
                  genFULLCSRjson.parameters[0].pin = bb
                  genFULLCSRjson.parameters[1].subject = `${strsubject}commonName,${CN};emailAddress,${CN}@163.com`
                  genFULLCSRjson.parameters[2].signed = rsigned
                  res = this.invokeProviderPub(genFULLCSRjson)
                  if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
                    var retu = res.returnvalue
                    var retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
                    var rvobj = JSON.parse(retub6)
                    rcode = rvobj.returnvalue[0].ret
                    if (rcode == 0) {
                      const retcsr = rvobj.returnvalue[2].value
                      return retcsr
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    //		}else{
    //			return "genKeyPairerr";
    //		}
  }
  this.genCSRYB = function (bb, CN, callf) {
    //		if(genKeyPairres&&csrpin.length==6){
    //			var bb=csrpin;
    genRAWCSRjson.parameters[0].pin = bb
    genRAWCSRjson.parameters[1].subject = `${strsubject}commonName,${CN};emailAddress,${CN}@163.com`
    const obj = this
    this.invokeProviderPubYB(genRAWCSRjson, (res) => {
      if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
        const retu = res.returnvalue
        const retub6 = obj.binayUtf8ToString(obj.base64decodearr(retu), 0)
        const rvobj = JSON.parse(retub6)
        //				strcipherdata = rvobj.returnvalue;
        let rcode = rvobj.returnvalue[0].ret
        if (rcode == 0) {
          const rawcsr = rvobj.returnvalue[2].value
          preSignjson.parameters[0].pin = bb
          preSignjson.parameters[1].msg = rawcsr
          obj.invokeProviderPubYB(preSignjson, (res) => {
            if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
              const retu = res.returnvalue
              const retub6 = obj.binayUtf8ToString(obj.base64decodearr(retu), 0)
              const rvobj = JSON.parse(retub6)
              //						strcipherdata = rvobj.returnvalue;
              rcode = rvobj.returnvalue[0].ret
              if (rcode != 0) {
                if (callf)
                  callf('pinerr')
                return
              }
              if (rcode == 0) {
                const q1 = rvobj.returnvalue[2].value
                const e = rvobj.returnvalue[3].value
                serverSignjson.parameters[0].pin = bb
                serverSignjson.parameters[2].q1 = q1
                serverSignjson.parameters[3].e = e
                obj.invokeProviderPubYB(serverSignjson, (res) => {
                  if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
                    const retu = res.returnvalue
                    const retub6 = obj.binayUtf8ToString(obj.base64decodearr(retu), 0)
                    const rvobj = JSON.parse(retub6)
                    const strcipherdata = rvobj.returnvalue[2].value
                    const realurl = `${serurl}?action=servPartSignByThresholdKey&encryptData=${strcipherdata}`
                    const rdata = obj.pwdGetSerData(realurl)
                    fullSignjson.parameters[0].pin = bb
                    fullSignjson.parameters[1].rd = rdata
                    fullSignjson.parameters[2].msg = ''
                    fullSignjson.parameters[3].type = 0
                    obj.invokeProviderPubYB(fullSignjson, (res) => {
                      if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
                        const retu = res.returnvalue
                        const retub6 = obj.binayUtf8ToString(obj.base64decodearr(retu), 0)
                        const rvobj = JSON.parse(retub6)
                        rcode = rvobj.returnvalue[0].ret
                        if (rcode == 0) {
                          const rsigned = rvobj.returnvalue[2].value
                          genFULLCSRjson.parameters[0].pin = bb
                          genFULLCSRjson.parameters[1].subject = `${strsubject}commonName,${CN};emailAddress,${CN}@163.com`
                          genFULLCSRjson.parameters[2].signed = rsigned
                          obj.invokeProviderPubYB(genFULLCSRjson, (res) => {
                            if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
                              const retu = res.returnvalue
                              const retub6 = obj.binayUtf8ToString(obj.base64decodearr(retu), 0)
                              const rvobj = JSON.parse(retub6)
                              rcode = rvobj.returnvalue[0].ret
                              if (rcode == 0) {
                                const retcsr = rvobj.returnvalue[2].value
                                if (callf)
                                  callf(retcsr)
                              }
                            }
                          })
                        }
                      }
                    })
                  }
                })
              }
            }
          })
        }
      }
    })
    //		}else{
    //			return "genKeyPairerr";
    //		}
  }
  this.invokeProviderPubYB = function (jsonstr, callf) {
    const snEnStrParam = this.base64encode(this.utf16to8(this.trimRight(JSON.stringify(jsonstr))))
    invokjson.params = snEnStrParam
    invokjson.pid = this.curpid
    const datac = this.base64encode(this.utf16to8(this.trimRight(JSON.stringify(invokjson))))
    const RZCIJSON = { rankey: pgeRZRandNum, datab: pgeRZDataB, datac }
    this.pwdGetDataYB(RZCIJSON, callf)
  }
  this.invokeProviderPub = function (jsonstr) {
    const snEnStrParam = this.base64encode(this.utf16to8(this.trimRight(JSON.stringify(jsonstr))))
    invokjson.params = snEnStrParam
    invokjson.pid = this.curpid
    const datac = this.base64encode(this.utf16to8(this.trimRight(JSON.stringify(invokjson))))
    const RZCIJSON = { rankey: pgeRZRandNum, datab: pgeRZDataB, datac }
    const res = this.pwdGetData(RZCIJSON)
    return res
  }
  this.servDownCert = function (strcsr, precomments) {
    servDownCertjson.parameters[2].csr = strcsr
    let res = this.invokeProviderPub(servDownCertjson)
    if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
      var retu = res.returnvalue
      var retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
      var rvobj = JSON.parse(retub6)
      const strcipherdata = rvobj.returnvalue[2].value
      precomments = encodeURIComponent(precomments)
      let realurl = `${serurl}?action=certificateApplicationDownload&encryptData=${strcipherdata}&precomments=${precomments}&ticket=${window.ticket || ''}`
      var strret = this.pwdGetSerData(realurl)
      decryptServerDatajson.parameters[0].cert = strret
      res = this.invokeProviderPub(decryptServerDatajson)
      if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
        var retu = res.returnvalue
        var retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
        var rvobj = JSON.parse(retub6)
        var strret = rvobj.returnvalue[2].value
        importSignCert.parameters[0].cert = strret
        res = this.invokeProviderPub(importSignCert)
        if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
          var retu = res.returnvalue
          var retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
          var rvobj = JSON.parse(retub6)
          const rcode = rvobj.returnvalue[0].ret
          if (rcode == 0) {
            const confirmInstallEnData = rvobj.returnvalue[2].value
            realurl = `${serurl}?action=confirmInstall&encryptData=${confirmInstallEnData}&ticket=${window.ticket || ''}`
            const resdata = this.pwdGetSerData(realurl)
            decryptServerDatajson2.parameters[0].data = resdata
            res = this.invokeProviderPub(decryptServerDatajson2)
            if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
              var retu = res.returnvalue
              var retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
              var rvobj = JSON.parse(retub6)
              var strret = rvobj.returnvalue[2].value
              retub6 = this.binayUtf8ToString(this.base64decodearr(strret), 0)
              rvobj = JSON.parse(retub6)
              const rescode = rvobj.rescode
              if (rescode == '3000000')
                return true
              else
                return false
            }
          }
          else {
            return false
          }
        }
      }
    }
  }
  this.servDownCertYB = function (strcsr, precomments, callf) {
    servDownCertjson.parameters[2].csr = strcsr
    const obj = this
    this.invokeProviderPubYB(servDownCertjson, (res) => {
      if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
        const retu = res.returnvalue
        const retub6 = obj.binayUtf8ToString(obj.base64decodearr(retu), 0)
        const rvobj = JSON.parse(retub6)
        const strcipherdata = rvobj.returnvalue[2].value
        precomments = encodeURIComponent(precomments)
        let realurl = `${serurl}?action=certificateApplicationDownload&encryptData=${strcipherdata}&precomments=${precomments}&ticket=${window.ticket || ''}`
        const strret = obj.pwdGetSerData(realurl)
        decryptServerDatajson.parameters[0].cert = strret
        obj.invokeProviderPubYB(decryptServerDatajson, (res) => {
          if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
            const retu = res.returnvalue
            const retub6 = obj.binayUtf8ToString(obj.base64decodearr(retu), 0)
            const rvobj = JSON.parse(retub6)
            const strret = rvobj.returnvalue[2].value
            importSignCert.parameters[0].cert = strret
            obj.invokeProviderPubYB(importSignCert, (res) => {
              if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
                const retu = res.returnvalue
                const retub6 = obj.binayUtf8ToString(obj.base64decodearr(retu), 0)
                const rvobj = JSON.parse(retub6)
                const rcode = rvobj.returnvalue[0].ret
                if (rcode == 0) {
                  const confirmInstallEnData = rvobj.returnvalue[2].value
                  realurl = `${serurl}?action=confirmInstall&encryptData=${confirmInstallEnData}&ticket=${window.ticket || ''}`
                  const resdata = obj.pwdGetSerData(realurl)
                  decryptServerDatajson2.parameters[0].data = resdata
                  obj.invokeProviderPubYB(decryptServerDatajson2, (res) => {
                    if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
                      const retu = res.returnvalue
                      let retub6 = obj.binayUtf8ToString(obj.base64decodearr(retu), 0)
                      let rvobj = JSON.parse(retub6)
                      const strret = rvobj.returnvalue[2].value
                      retub6 = obj.binayUtf8ToString(obj.base64decodearr(strret), 0)
                      rvobj = JSON.parse(retub6)
                      const rescode = rvobj.rescode
                      if (rescode == '3000000') {
                        if (callf)
                          callf(true)
                      }
                      else {
                        if (callf)
                          callf(false)
                      }
                    }
                  })
                }
                else {
                  if (callf)
                    callf(false)
                }
              }
            })
          }
        })
      }
    })
  }
  //	this.xtSign = function(bb,msg){
  //		msg = this.base64encode(this.utf16to8(this.trimRight(msg)));
  //		preSignjson.parameters[0].pin=bb;
  //		preSignjson.parameters[1].msg=msg;
  //		var res=this.invokeProviderPub(preSignjson);
  //		if(res.hasOwnProperty("returnvalue")&&res.returnvalue!="")
  //		{
  //			var retu = res.returnvalue;
  //			var retub6 = this.binayUtf8ToString(this.base64decodearr(retu),0);
  //			var rvobj = JSON.parse(retub6);
  //			var rcode = rvobj.returnvalue[0].ret;
  //			if(rcode==0){
  //				var q1= rvobj.returnvalue[2].value;
  //				var e= rvobj.returnvalue[3].value;
  //				serverSignjson.parameters[0].pin=bb;
  //				serverSignjson.parameters[2].q1=q1;
  //				serverSignjson.parameters[3].e=e;
  //				res=this.invokeProviderPub(serverSignjson);
  //				if(res.hasOwnProperty("returnvalue")&&res.returnvalue!="")
  //				{
  //					var retu = res.returnvalue;
  //					var retub6 = this.binayUtf8ToString(this.base64decodearr(retu),0);
  //					var rvobj = JSON.parse(retub6);
  //					var strcipherdata = rvobj.returnvalue[2].value;
  //					realurl = serurl+"?action=servPartSignByThresholdKey&encryptData="+strcipherdata;
  //					rdata=this.pwdGetSerData(realurl);
  //					fullSignjson.parameters[0].pin=bb;
  //					fullSignjson.parameters[1].rd=rdata;
  //					fullSignjson.parameters[2].msg=msg;
  //					fullSignjson.parameters[3].type=1;
  //					res=this.invokeProviderPub(fullSignjson);
  //					if(res.hasOwnProperty("returnvalue")&&res.returnvalue!="")
  //					{
  //						var retu = res.returnvalue;
  //						var retub6 = this.binayUtf8ToString(this.base64decodearr(retu),0);
  //						var rvobj = JSON.parse(retub6);
  //						rcode = rvobj.returnvalue[0].ret;
  //						if(rcode==0){
  //							var retstr=rvobj.returnvalue[2].value;
  //							return retstr;
  //						}else{
  //							return "协同签名失败！";
  //						}
  //					}
  //				}
  //			}
  //		}
  //	}
  this.xtSign = function (bb, msg) {
    msg = this.base64encode(this.utf16to8(this.trimRight(msg)))
    preSignjson.parameters[0].pin = bb
    preSignjson.parameters[1].msg = msg
    let res = this.invokeProviderPub(preSignjson)
    if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
      var retu = res.returnvalue
      var retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
      var rvobj = JSON.parse(retub6)
      let rcode = rvobj.returnvalue[0].ret
      if (rcode == 0) {
        const q1 = rvobj.returnvalue[2].value
        const e = rvobj.returnvalue[3].value
        serverSignjson.parameters[0].pin = bb
        serverSignjson.parameters[2].q1 = q1
        serverSignjson.parameters[3].e = e
        res = this.invokeProviderPub(serverSignjson)
        if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
          var retu = res.returnvalue
          var retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
          var rvobj = JSON.parse(retub6)
          const strcipherdata = rvobj.returnvalue[2].value
          realurl = `${serurl}?action=servPartSignByThresholdKey&encryptData=${strcipherdata}`
          rdata = this.pwdGetSerData(realurl)
          fullSign4SFTjson.parameters[0].pin = bb
          fullSign4SFTjson.parameters[1].rd = rdata
          fullSign4SFTjson.parameters[2].msg = msg
          fullSign4SFTjson.parameters[3].type = 1
          res = this.invokeProviderPub(fullSign4SFTjson)
          if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
            var retu = res.returnvalue
            var retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
            var rvobj = JSON.parse(retub6)
            rcode = rvobj.returnvalue[0].ret
            if (rcode == 0) {
              const retstr = rvobj.returnvalue[2].value
              return retstr
            }
            else {
              return '协同签名失败！'
            }
          }
        }
      }
    }
  }
  this.xtSignYB = function (bb, msg, callf, errorf, params) {
    if (params && params.url)
      serurl = params.url
    try {
      msg = this.base64encode(this.utf16to8(this.trimRight(msg)))
      preSignjson.parameters[0].pin = bb
      preSignjson.parameters[1].msg = msg
      const obj = this
      this.invokeProviderPubYB(preSignjson, (res) => {
        console.log('this.invokeProviderPubYB preSignjson is -', preSignjson)
        console.log('this.invokeProviderPubYB res is -', res)

        try {
          if (!res || !res.hasOwnProperty('returnvalue') || res.returnvalue == '') {
            if (errorf)
              errorf('预签名失败：返回值为空')
            return
          }
          // 打印每一步变量并用不同颜色区分
          const retu = res.returnvalue
          console.log('\x1B[35m[retu]\x1B[0m', retu) // 紫色

          const retub6 = obj.binayUtf8ToString(obj.base64decodearr(retu), 0)
          console.log('\x1B[36m[retub6]\x1B[0m', retub6) // 青色

          const rvobj = JSON.parse(retub6)
          console.log('\x1B[33m[rvobj]\x1B[0m', rvobj) // 黄色

          if (!rvobj.returnvalue || !rvobj.returnvalue[0]) {
            if (errorf)
              errorf('预签名失败：返回数据格式错误')
            return
          }

          let rcode = rvobj.returnvalue[0].ret
          console.log('\x1B[32m[rcode]\x1B[0m', rcode) // 绿色
          if (rcode != 0) {
            if (errorf)
              errorf(`预签名失败：错误码 ${rcode}`)
            return
          }
          const q1 = rvobj.returnvalue[2].value
          const e = rvobj.returnvalue[3].value
          if (!q1 || !e) {
            if (errorf)
              errorf('预签名失败：未获取到 q1 或 e 值')
            return
          }
          serverSignjson.parameters[0].pin = bb
          serverSignjson.parameters[2].q1 = q1
          serverSignjson.parameters[3].e = e
          obj.invokeProviderPubYB(serverSignjson, (res) => {
            try {
              if (!res || !res.hasOwnProperty('returnvalue') || res.returnvalue == '') {
                if (errorf)
                  errorf('服务端签名失败：返回值为空')
                return
              }
              const retu = res.returnvalue
              const retub6 = obj.binayUtf8ToString(obj.base64decodearr(retu), 0)
              const rvobj = JSON.parse(retub6)
              if (!rvobj.returnvalue || !rvobj.returnvalue[2]) {
                if (errorf)
                  errorf('服务端签名失败：返回数据格式错误')
                return
              }
              const strcipherdata = rvobj.returnvalue[2].value
              if (!strcipherdata) {
                if (errorf)
                  errorf('服务端签名失败：未获取到加密数据')
                return
              }
              const realurl = `${serurl}?action=servPartSignByThresholdKey&encryptData=${strcipherdata}`
              const rdata = obj.pwdGetSerData(realurl)
              if (!rdata) {
                if (errorf)
                  errorf('获取服务端数据失败')
                return
              }
              fullSign4SFTjson.parameters[0].pin = bb
              fullSign4SFTjson.parameters[1].rd = rdata
              fullSign4SFTjson.parameters[2].msg = msg
              fullSign4SFTjson.parameters[3].type = 1
              obj.invokeProviderPubYB(fullSign4SFTjson, (res) => {
                try {
                  if (!res || !res.hasOwnProperty('returnvalue') || res.returnvalue == '') {
                    if (errorf)
                      errorf('完整签名失败：返回值为空')
                    return
                  }
                  const retu = res.returnvalue
                  const retub6 = obj.binayUtf8ToString(obj.base64decodearr(retu), 0)
                  const rvobj = JSON.parse(retub6)
                  if (!rvobj.returnvalue || !rvobj.returnvalue[0]) {
                    if (errorf)
                      errorf('完整签名失败：返回数据格式错误')
                    return
                  }
                  rcode = rvobj.returnvalue[0].ret
                  if (rcode == 0) {
                    if (!rvobj.returnvalue[2]) {
                      if (errorf)
                        errorf('完整签名失败：未获取到签名值')
                      return
                    }
                    const retstr = rvobj.returnvalue[2].value
                    if (callf)
                      callf(retstr)
                  }
                  else {
                    if (errorf)
                      errorf(`协同签名失败：错误码 ${rcode}`)
                  }
                }
                catch (error) {
                  if (errorf)
                    errorf(`完整签名异常：${error.message || error}`)
                }
              })
            }
            catch (error) {
              if (errorf)
                errorf(`服务端签名异常：${error.message || error}`)
            }
          })
        }
        catch (error) {
          if (errorf)
            errorf(`预签名异常：${error.message || error}`)
        }
      })
    }
    catch (error) {
      if (errorf)
        errorf(`签名初始化异常：${error.message || error}`)
    }
  }
  this.xtVerify = function (strsigned, msg) {
    verifyjson.parameters[0].signed = strsigned
    verifyjson.parameters[1].src = this.base64encode(this.utf16to8(this.trimRight(msg)))
    const res = this.invokeProviderPub(verifyjson)
    if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
      const retu = res.returnvalue
      const retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
      const rvobj = JSON.parse(retub6)
      const rcode = rvobj.returnvalue[0].ret
      if (rcode == 0)
        return true
      else
        return false
    }
  }
  this.verifyP7Attach = function (encryptData) {
    //		serverVerify.parameters[0].src=strsigned;
    //		var res=this.invokeProviderPub(serverVerify);
    //		if(res.hasOwnProperty("returnvalue")&&res.returnvalue!=""){
    //			var retValue = res.returnvalue;
    //			var retub6 = this.binayUtf8ToString(this.base64decodearr(retValue),0);
    //			var rvobj = JSON.parse(retub6);
    //			var rcode = rvobj.returnvalue[0].ret;
    //			if(rcode == 0){
    //				var encryptData= rvobj.returnvalue[2].value;
    const realurl = `${serurl}?action=verifySignByP7&encryptData=${encryptData}`
    const resdata = this.pwdGetSerData(realurl)
    decryptServerDatajson2.parameters[0].data = resdata
    res = this.invokeProviderPub(decryptServerDatajson2)
    if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
      const retu = res.returnvalue
      retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
      rvobj = JSON.parse(retub6)
      const strret = rvobj.returnvalue[2].value
      retub6 = this.binayUtf8ToString(this.base64decodearr(strret), 0)
      rvobj = JSON.parse(retub6)
      const rescode = rvobj.rescode
      if (rescode == '3000000')
        return true
      else
        return false
    }
    //			}
    //		}
  }
  this.verifyP7AttachYB = function (encryptData, callf) {
    //		serverVerify.parameters[0].src=strsigned;
    //		var res=this.invokeProviderPub(serverVerify);
    //		if(res.hasOwnProperty("returnvalue")&&res.returnvalue!=""){
    //			var retValue = res.returnvalue;
    //			var retub6 = this.binayUtf8ToString(this.base64decodearr(retValue),0);
    //			var rvobj = JSON.parse(retub6);
    //			var rcode = rvobj.returnvalue[0].ret;
    //			if(rcode == 0){
    //				var encryptData= rvobj.returnvalue[2].value;
    const realurl = `${serurl}?action=verifySignByP7&encryptData=${encryptData}`
    const resdata = this.pwdGetSerData(realurl)
    decryptServerDatajson2.parameters[0].data = resdata
    const obj = this
    this.invokeProviderPubYB(decryptServerDatajson2, (res) => {
      if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
        const retu = res.returnvalue
        retub6 = obj.binayUtf8ToString(obj.base64decodearr(retu), 0)
        let rvobj = JSON.parse(retub6)
        const strret = rvobj.returnvalue[2].value
        var retub6 = obj.binayUtf8ToString(obj.base64decodearr(strret), 0)
        rvobj = JSON.parse(retub6)
        const rescode = rvobj.rescode
        if (rescode == '3000000') {
          if (callf)
            callf(true)
        }
        else {
          if (callf)
            callf(false)
        }
      }
    })
    //			}
    //		}
  }
  this.sm2Encrypt = function (msg) {
    encryptjson.parameters[0].src = this.base64encode(this.utf16to8(this.trimRight(msg)))
    //		console.time("SM2EN");
    const res = this.invokeProviderPub(encryptjson)
    //		console.timeEnd("SM2EN");
    if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
      const retu = res.returnvalue
      const retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
      const rvobj = JSON.parse(retub6)
      const rcode = rvobj.returnvalue[0].ret
      if (rcode == 0) {
        const strret = rvobj.returnvalue[2].value
        return strret
      }
    }
  }
  this.sm2EncryptYB = function (msg, callf) {
    encryptjson.parameters[0].src = this.base64encode(this.utf16to8(this.trimRight(msg)))
    //		console.time("SM2EN");
    const obj = this
    this.invokeProviderPubYB(encryptjson, (res) => {
      //		console.timeEnd("SM2EN");
      if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
        const retu = res.returnvalue
        const retub6 = obj.binayUtf8ToString(obj.base64decodearr(retu), 0)
        const rvobj = JSON.parse(retub6)
        const rcode = rvobj.returnvalue[0].ret
        if (rcode == 0) {
          const strret = rvobj.returnvalue[2].value
          if (callf)
            callf(strret)
        }
      }
    })
  }
  this.sm2Decrypt = function (pin, cipher) {
    clnDecryptjson.parameters[0].pin = pin
    clnDecryptjson.parameters[1].cipher = cipher
    let res = this.invokeProviderPub(clnDecryptjson)
    if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
      var retu = res.returnvalue
      var retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
      var rvobj = JSON.parse(retub6)
      var rcode = rvobj.returnvalue[0].ret
      if (rcode == 0) {
        const c1 = rvobj.returnvalue[2].value
        servDecryptjson.parameters[0].pin = pin
        servDecryptjson.parameters[2].c1 = c1
        res = this.invokeProviderPub(servDecryptjson)
        if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
          var retu = res.returnvalue
          var retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
          var rvobj = JSON.parse(retub6)
          const strcipherdata = rvobj.returnvalue[2].value
          const realurl = `${serurl}?action=servPartDecryptByThresholdKey&encryptData=${strcipherdata}`
          const rdata = this.pwdGetSerData(realurl)
          if (rdata.length > 0) {
            fullDecryptjson.parameters[0].pin = pin
            fullDecryptjson.parameters[1].rdata = rdata
            fullDecryptjson.parameters[2].cipher = cipher
            res = this.invokeProviderPub(fullDecryptjson)
            if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
              var retu = res.returnvalue
              var retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
              var rvobj = JSON.parse(retub6)
              var rcode = rvobj.returnvalue[0].ret
              if (rcode == 0) {
                let ders = rvobj.returnvalue[2].value
                ders = this.binayUtf8ToString(this.base64decodearr(ders), 0)
                return ders
              }
              else {
                return '-1'
              }
            }
          }
        }
      }
    }
  }
  this.sm2DecryptYB = function (pin, cipher, callf) {
    clnDecryptjson.parameters[0].pin = pin
    clnDecryptjson.parameters[1].cipher = cipher
    const obj = this
    this.invokeProviderPubYB(clnDecryptjson, (res) => {
      if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
        const retu = res.returnvalue
        const retub6 = obj.binayUtf8ToString(obj.base64decodearr(retu), 0)
        const rvobj = JSON.parse(retub6)
        const rcode = rvobj.returnvalue[0].ret
        if (rcode == 0) {
          const c1 = rvobj.returnvalue[2].value
          servDecryptjson.parameters[0].pin = pin
          servDecryptjson.parameters[2].c1 = c1
          obj.invokeProviderPubYB(servDecryptjson, (res) => {
            if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
              const retu = res.returnvalue
              const retub6 = obj.binayUtf8ToString(obj.base64decodearr(retu), 0)
              const rvobj = JSON.parse(retub6)
              const strcipherdata = rvobj.returnvalue[2].value
              const realurl = `${serurl}?action=servPartDecryptByThresholdKey&encryptData=${strcipherdata}`
              const rdata = obj.pwdGetSerData(realurl)
              if (rdata.length > 0) {
                fullDecryptjson.parameters[0].pin = pin
                fullDecryptjson.parameters[1].rdata = rdata
                fullDecryptjson.parameters[2].cipher = cipher
                obj.invokeProviderPubYB(fullDecryptjson, (res) => {
                  if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
                    const retu = res.returnvalue
                    const retub6 = obj.binayUtf8ToString(obj.base64decodearr(retu), 0)
                    const rvobj = JSON.parse(retub6)
                    const rcode = rvobj.returnvalue[0].ret
                    if (rcode == 0) {
                      let ders = rvobj.returnvalue[2].value
                      ders = obj.binayUtf8ToString(obj.base64decodearr(ders), 0)
                      if (callf)
                        callf(ders)
                    }
                    else {
                      if (callf)
                        callf('-1')
                    }
                  }
                })
              }
            }
          })
        }
      }
    })
  }
  this.sm4encrypt = function (imode, msg) {
    SM4Encrytjson.parameters[0].mode = parseInt(imode)
    SM4Encrytjson.parameters[1].iv = this.base64encode(this.utf16to8(this.trimRight(iv)))
    SM4Encrytjson.parameters[2].plain = this.base64encode(this.utf16to8(this.trimRight(msg)))
    SM4Encrytjson.parameters[3].key = this.base64encode(this.utf16to8(this.trimRight(sm4key)))
    //		console.time("sm4en");
    const res = this.invokeProviderPub(SM4Encrytjson)
    //		console.timeEnd("sm4en");
    if (imode == '111')
      imode = 'ECB'
    else if (imode == '114')
      imode = 'CBC'
    if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
      const retu = res.returnvalue
      const retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
      const rvobj = JSON.parse(retub6)
      const rcode = rvobj.returnvalue[0].ret
      if (rcode == 0) {
        const strret = rvobj.returnvalue[2].value
        return strret
      }
      else {
        return '-1'
      }
    }
  }
  this.sm4decrypt = function (imode, cipher) {
    SM4Decrytjson.parameters[0].mode = parseInt(imode)
    SM4Decrytjson.parameters[1].iv = this.base64encode(this.utf16to8(this.trimRight(iv)))
    SM4Decrytjson.parameters[2].chiper = cipher
    SM4Decrytjson.parameters[3].key = this.base64encode(this.utf16to8(this.trimRight(sm4key)))
    const res = this.invokeProviderPub(SM4Decrytjson)
    if (imode == '111')
      imode = 'ECB'
    else if (imode == '114')
      imode = 'CBC'
    if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
      const retu = res.returnvalue
      const retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
      const rvobj = JSON.parse(retub6)
      const rcode = rvobj.returnvalue[0].ret
      if (rcode == 0) {
        let strret = rvobj.returnvalue[2].value
        //				strret=hexToString(strret);
        strret = this.binayUtf8ToString(this.base64decodearr(strret), 0)
        return strret
      }
      else {
        return '-1'
      }
    }
  }
  this.SM3Digest = function (msg) {
    SM3Digestjson.parameters[0].pSrc = msg
    const res = this.invokeProviderPub(SM3Digestjson)
    if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
      const retu = res.returnvalue
      const retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
      const rvobj = JSON.parse(retub6)
      const rcode = rvobj.returnvalue[0].ret
      if (rcode == 0) {
        const strret = rvobj.returnvalue[2].value
        return strret
      }
      else {
        return '-1'
      }
    }
  }
  this.getLibVersion = function () {
    const res = this.invokeProviderPub(getLibVersionjson)
    if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
      const retu = res.returnvalue
      const retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
      const rvobj = JSON.parse(retub6)
      const rcode = rvobj.returnvalue[0].ret
      if (rcode == 0) {
        const version = rvobj.returnvalue[2].value
        return version
      }
      else {
        return '-1'
      }
    }
  }
  this.getLibVersionYB = function (callf) {
    const obj = this
    this.invokeProviderPubYB(getLibVersionjson, (res) => {
      if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
        const retu = res.returnvalue
        const retub6 = obj.binayUtf8ToString(obj.base64decodearr(retu), 0)
        const rvobj = JSON.parse(retub6)
        const rcode = rvobj.returnvalue[0].ret
        if (rcode == 0) {
          const version = rvobj.returnvalue[2].value
          if (callf)
            callf(version)
        }
        else {
          if (callf)
            callf('-1')
        }
      }
    })
  }
  this.getSerialNo = function () {
    const res = this.invokeProviderPub(getSerialNojson)
    if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
      const retu = res.returnvalue
      const retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
      const rvobj = JSON.parse(retub6)
      const rcode = rvobj.returnvalue[0].ret
      if (rcode == 0) {
        const version = rvobj.returnvalue[2].value
        return version
      }
      else {
        return '-1'
      }
    }
  }
  this.getSerialNoYB = function (callf) {
    const obj = this
    this.invokeProviderPubYB(getSerialNojson, (res) => {
      if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
        const retu = res.returnvalue
        const retub6 = obj.binayUtf8ToString(obj.base64decodearr(retu), 0)
        const rvobj = JSON.parse(retub6)
        const rcode = rvobj.returnvalue[0].ret
        if (rcode == 0) {
          const version = rvobj.returnvalue[2].value
          if (callf)
            callf(version)
        }
        else {
          if (callf)
            callf('-1')
        }
      }
    })
  }
  this.getMacAddress = function () {
    const res = this.invokeProviderPub(getMacAddressjson)
    if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
      const retu = res.returnvalue
      const retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
      const rvobj = JSON.parse(retub6)
      const rcode = rvobj.returnvalue[0].ret
      if (rcode == 0) {
        const macaddr = rvobj.returnvalue[2].value
        return macaddr
      }
      else {
        return '-1'
      }
    }
  }
  this.getMacAddressYB = function (callf) {
    const obj = this
    this.invokeProviderPubYB(getMacAddressjson, (res) => {
      if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
        const retu = res.returnvalue
        const retub6 = obj.binayUtf8ToString(obj.base64decodearr(retu), 0)
        const rvobj = JSON.parse(retub6)
        const rcode = rvobj.returnvalue[0].ret
        if (rcode == 0) {
          const macaddr = rvobj.returnvalue[2].value
          if (callf)
            callf(macaddr)
        }
        else {
          if (callf)
            callf('-1')
        }
      }
    })
  }
  this.verifypin = function (pin) {
    verifypinjson.parameters[0].pin = pin
    const res = this.invokeProviderPub(verifypinjson)
    if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
      const retu = res.returnvalue
      const retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
      const rvobj = JSON.parse(retub6)
      const rcode = rvobj.returnvalue[0].ret
      if (rcode == 0)
        return true
      else
        return false
    }
  }
  this.verifypinYB = function (pin, callf) {
    const obj = this
    verifypinjson.parameters[0].pin = pin
    this.invokeProviderPubYB(verifypinjson, (res) => {
      if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
        const retu = res.returnvalue
        const retub6 = obj.binayUtf8ToString(obj.base64decodearr(retu), 0)
        const rvobj = JSON.parse(retub6)
        const rcode = rvobj.returnvalue[0].ret
        if (rcode == 0) {
          if (callf)
            callf(true)
        }
        else {
          if (callf)
            callf(false)
        }
      }
    })
  }
  this.modifypin = function (oldpin, newpin) {
    modifyclnpinjson.parameters[0].pin = oldpin
    modifyclnpinjson.parameters[1].newpin = newpin
    let res = this.invokeProviderPub(modifyclnpinjson)
    if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
      var retu = res.returnvalue
      var retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
      var rvobj = JSON.parse(retub6)
      const rcode = rvobj.returnvalue[0].ret
      if (rcode == 0) {
        modifyserpinjson.parameters[0].pin = oldpin
        modifyserpinjson.parameters[1].newpin = newpin
        res = this.invokeProviderPub(modifyserpinjson)
        if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
          var retu = res.returnvalue
          var retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
          var rvobj = JSON.parse(retub6)
          const strcipherdata = rvobj.returnvalue[2].value
          //					var realurl = "{self.url}/SM2DecentralizedPrivatekeySignature/SM2Servlet?action=modifyServUserPin&encryptData={strcipherdata}";
          const realurl = `${serurl}?action=modifyServUserPin&encryptData=${strcipherdata}`
          const rdata = this.pwdGetSerData(realurl)
          decryptServerDatajson2.parameters[0].data = rdata
          res = this.invokeProviderPub(decryptServerDatajson2)
          if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
            var retu = res.returnvalue
            var retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
            var rvobj = JSON.parse(retub6)
            const strret = rvobj.returnvalue[2].value
            retub6 = this.binayUtf8ToString(this.base64decodearr(strret), 0)
            rvobj = JSON.parse(retub6)
            const rescode = rvobj.rescode
            if (rescode == '3000000')
              return true
            else
              return false
          }
        }
      }
      else {
        return false
      }
    }
  }
  this.modifypinYB = function (oldpin, newpin, callf) {
    modifyclnpinjson.parameters[0].pin = oldpin
    modifyclnpinjson.parameters[1].newpin = newpin
    const obj = this
    this.invokeProviderPubYB(modifyclnpinjson, (res) => {
      if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
        const retu = res.returnvalue
        const retub6 = obj.binayUtf8ToString(obj.base64decodearr(retu), 0)
        const rvobj = JSON.parse(retub6)
        const rcode = rvobj.returnvalue[0].ret
        if (rcode == 0) {
          modifyserpinjson.parameters[0].pin = oldpin
          modifyserpinjson.parameters[1].newpin = newpin
          obj.invokeProviderPubYB(modifyserpinjson, (res) => {
            if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
              const retu = res.returnvalue
              const retub6 = obj.binayUtf8ToString(obj.base64decodearr(retu), 0)
              const rvobj = JSON.parse(retub6)
              const strcipherdata = rvobj.returnvalue[2].value
              //					var realurl = "{self.url}/SM2DecentralizedPrivatekeySignature/SM2Servlet?action=modifyServUserPin&encryptData={strcipherdata}";
              const realurl = `${serurl}?action=modifyServUserPin&encryptData=${strcipherdata}`
              const rdata = obj.pwdGetSerData(realurl)
              decryptServerDatajson2.parameters[0].data = rdata
              obj.invokeProviderPubYB(decryptServerDatajson2, (res) => {
                if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
                  const retu = res.returnvalue
                  let retub6 = obj.binayUtf8ToString(obj.base64decodearr(retu), 0)
                  let rvobj = JSON.parse(retub6)
                  const strret = rvobj.returnvalue[2].value
                  retub6 = obj.binayUtf8ToString(obj.base64decodearr(strret), 0)
                  rvobj = JSON.parse(retub6)
                  const rescode = rvobj.rescode
                  if (rescode == '3000000') {
                    if (callf)
                      callf(true)
                  }
                  else {
                    if (callf)
                      callf(false)
                  }
                }
              })
            }
          })
        }
        else {
          if (callf)
            callf(false)
        }
      }
    })
  }
  this.deletecontainer = function () {
    const res = this.invokeProviderPub(deletecontainerjson)
    if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
      const retu = res.returnvalue
      const retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
      const rvobj = JSON.parse(retub6)
      const rcode = rvobj.returnvalue[0].ret
      if (rcode == 0)
        return true
      else
        return false
    }
  }
  this.deletecontainerYB = function (callf) {
    const obj = this
    this.invokeProviderPubYB(deletecontainerjson, (res) => {
      if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
        const retu = res.returnvalue
        const retub6 = obj.binayUtf8ToString(obj.base64decodearr(retu), 0)
        const rvobj = JSON.parse(retub6)
        const rcode = rvobj.returnvalue[0].ret
        if (rcode == 0) {
          if (callf)
            callf(true)
        }
        else {
          if (callf)
            callf(false)
        }
      }
    })
  }
  this.deleteserver = function () {
    let res = this.invokeProviderPub(certificateRevocation)
    if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
      var retu = res.returnvalue
      var retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
      var rvobj = JSON.parse(retub6)
      const rcode = rvobj.returnvalue[0].ret
      if (rcode == 0) {
        const certificateRevocationEnData = rvobj.returnvalue[2].value
        const realurl = `${serurl}?action=certificateRevocation&encryptData=${certificateRevocationEnData}`
        const resdata = this.pwdGetSerData(realurl)
        decryptServerDatajson2.parameters[0].data = resdata
        res = this.invokeProviderPub(decryptServerDatajson2)
        if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
          var retu = res.returnvalue
          var retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
          var rvobj = JSON.parse(retub6)
          const strret = rvobj.returnvalue[2].value
          retub6 = this.binayUtf8ToString(this.base64decodearr(strret), 0)
          rvobj = JSON.parse(retub6)
          const rescode = rvobj.rescode
          if (rescode == '3000000')
            return true
          else
            return false
        }
      }
      else {
        return false
      }
    }
  }
  this.deleteserverYB = function (callf) {
    const obj = this
    this.invokeProviderPubYB(certificateRevocation, (res) => {
      if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
        const retu = res.returnvalue
        const retub6 = obj.binayUtf8ToString(obj.base64decodearr(retu), 0)
        const rvobj = JSON.parse(retub6)
        const rcode = rvobj.returnvalue[0].ret
        if (rcode == 0) {
          const certificateRevocationEnData = rvobj.returnvalue[2].value
          const realurl = `${serurl}?action=certificateRevocation&encryptData=${certificateRevocationEnData}`
          const resdata = obj.pwdGetSerData(realurl)
          decryptServerDatajson2.parameters[0].data = resdata
          obj.invokeProviderPubYB(decryptServerDatajson2, (res) => {
            if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
              const retu = res.returnvalue
              let retub6 = obj.binayUtf8ToString(obj.base64decodearr(retu), 0)
              let rvobj = JSON.parse(retub6)
              const strret = rvobj.returnvalue[2].value
              retub6 = obj.binayUtf8ToString(obj.base64decodearr(strret), 0)
              rvobj = JSON.parse(retub6)
              const rescode = rvobj.rescode
              if (rescode == '3000000') {
                if (callf)
                  callf(true)
              }
              else {
                if (callf)
                  callf(false)
              }
            }
          })
        }
        else {
          if (callf)
            callf(false)
        }
      }
    })
  }
  this.certificatequery = function () {
    let res = this.invokeProviderPub(certificateQueryjson)
    if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
      var retu = res.returnvalue
      var retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
      var rvobj = JSON.parse(retub6)
      const rcode = rvobj.returnvalue[0].ret
      if (rcode == 0) {
        const certificateQueryEnData = rvobj.returnvalue[2].value
        const realurl = `${serurl}?action=certificateQuery&encryptData=${certificateQueryEnData}`
        const resdata = this.pwdGetSerData(realurl)
        decryptServerDatajson2.parameters[0].data = resdata
        res = this.invokeProviderPub(decryptServerDatajson2)
        if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
          var retu = res.returnvalue
          var retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
          var rvobj = JSON.parse(retub6)
          const strret = rvobj.returnvalue[2].value
          retub6 = this.binayUtf8ToString(this.base64decodearr(strret), 0)
          rvobj = JSON.parse(retub6)
          const rescode = rvobj.rescode
          if (rescode == '3000000')
            return true
          else
            return false
        }
      }
      else {
        return false
      }
    }
  }
  this.certificatequeryYB = function (callf) {
    const obj = this
    this.invokeProviderPubYB(certificateQueryjson, (res) => {
      if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
        const retu = res.returnvalue
        const retub6 = obj.binayUtf8ToString(obj.base64decodearr(retu), 0)
        const rvobj = JSON.parse(retub6)
        const rcode = rvobj.returnvalue[0].ret
        if (rcode == 0) {
          const certificateQueryEnData = rvobj.returnvalue[2].value
          const realurl = `${serurl}?action=certificateQuery&encryptData=${certificateQueryEnData}`
          const resdata = obj.pwdGetSerData(realurl)
          decryptServerDatajson2.parameters[0].data = resdata
          obj.invokeProviderPubYB(decryptServerDatajson2, (res) => {
            if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
              const retu = res.returnvalue
              let retub6 = obj.binayUtf8ToString(obj.base64decodearr(retu), 0)
              let rvobj = JSON.parse(retub6)
              const strret = rvobj.returnvalue[2].value
              retub6 = obj.binayUtf8ToString(obj.base64decodearr(strret), 0)
              rvobj = JSON.parse(retub6)
              const rescode = rvobj.rescode
              if (rescode == '3000000') {
                if (callf)
                  callf(true)
              }
              else {
                if (callf)
                  callf(false)
              }
            }
          })
        }
        else {
          if (callf)
            callf(false)
        }
      }
    })
  }
  this.invokeProvider = function (bb, flag) {
    let datac = ''
    if (flag == 3)
      datac = bb
    else if (flag == 2)
      var snEnStrParam = bb
    else
      var snEnStrParam = this.base64encode(this.utf16to8(this.trimRight(JSON.stringify(bb))))
    invokjson.params = snEnStrParam
    invokjson.pid = this.curpid
    //		var datac = getEnStr(pgeRZRandNum,invokjson);
    if (datac == '')
      datac = this.base64encode(this.utf16to8(this.trimRight(JSON.stringify(invokjson))))
    const RZCIJSON = { rankey: pgeRZRandNum, datab: pgeRZDataB, datac }
    const res = this.pwdGetData(RZCIJSON)
    if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
      const retu = res.returnvalue
      const retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
      var rvobj = JSON.parse(retub6)
      return rvobj.returnvalue
    }
    else {
      var rvobj = [{ ret: res.ecode }, { errormessage: res.message }, { value: '' }]
      return rvobj
    }
  }
  this.invokeProviderInner = function (bb, kf) {
    const snEnStrParam = this.base64encode(this.utf16to8(this.trimRight(JSON.stringify(bb))))
    invokjson.params = snEnStrParam
    invokjson.pid = this.curpid
    //		var datac = getEnStr(pgeRZRandNum,invokjson);
    const datac = this.base64encode(this.utf16to8(this.trimRight(JSON.stringify(invokjson))))
    const RZCIJSON = { rankey: pgeRZRandNum, datab: pgeRZDataB, datac }
    const res = this.pwdGetData(RZCIJSON)
    if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
      const retu = res.returnvalue
      const retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
      var rvobj = JSON.parse(retub6)
      return rvobj.returnvalue
    }
    else {
      if (res.ecode <= -900) {
        if (kf == 'wq') {
          this.wqinterv = 0
          this.wqfirstflag = 0
        }
        else if (kf == 'tdr') {
          this.tdrinterv = 0
          this.tdrfirstflag = 0
        }
        else if (kf == 'ft') {
          this.ftinterv = 0
          this.ftfirstflag = 0
        }
        else if (kf == 'ft2G') {
          this.ft2Ginterv = 0
          this.ft2Gfirstflag = 0
        }
      }
      var rvobj = [{ ret: res.ecode }, { errormessage: res.message }, { value: '' }]
      return rvobj
    }
  }
  this.invokeProvider33 = function (bb) {
    const snEnStrParam = this.base64encode(this.utf16to8(this.trimRight(JSON.stringify(bb))))
    invokjson.params = snEnStrParam
    invokjson.pid = this.curpid
    //		var datac = getEnStr(pgeRZRandNum,invokjson);
    const datac = this.base64encode(this.utf16to8(this.trimRight(JSON.stringify(invokjson))))
    const RZCIJSON = { rankey: pgeRZRandNum, datab: pgeRZDataB, datac }
    const res = this.pwdGetData33(RZCIJSON)
    if (res.hasOwnProperty('returnvalue') && res.returnvalue != '') {
      const retu = res.returnvalue
      const retub6 = this.binayUtf8ToString(this.base64decodearr(retu), 0)
      var rvobj = JSON.parse(retub6)
      return rvobj.returnvalue
    }
    else {
      var rvobj = [{ ret: res.ecode }, { errormessage: res.message }, { value: '' }]
      return rvobj
    }
  }
  this.getErrors = function (eid) {
    errjson.errcode = eid
    //		var datac = getEnStr(pgeRZRandNum,errjson);
    const datac = this.base64encode(this.utf16to8(this.trimRight(JSON.stringify(errjson))))
    const RZCIJSON = { rankey: pgeRZRandNum, datab: pgeRZDataB, datac }
    return this.pwdGetData(RZCIJSON)
  }
  this.getVersion = function () {
    //		var datac = getEnStr(pgeRZRandNum,versionjson);
    const datac = this.base64encode(this.utf16to8(this.trimRight(JSON.stringify(versionjson))))
    const RZCIJSON = { rankey: pgeRZRandNum, datab: pgeRZDataB, datac }
    return this.pwdGetData(RZCIJSON)
  }
  this.openLog = function () {
    const datac = this.base64encode(this.utf16to8(this.trimRight(JSON.stringify(openlogjson))))
    const RZCIJSON = { rankey: pgeRZRandNum, datab: pgeRZDataB, datac }
    return this.pwdGetData(RZCIJSON)
  }
  this.closeLog = function () {
    const datac = this.base64encode(this.utf16to8(this.trimRight(JSON.stringify(closelogjson))))
    const RZCIJSON = { rankey: pgeRZRandNum, datab: pgeRZDataB, datac }
    return this.pwdGetData(RZCIJSON)
  }
  this.getLogStatus = function () {
    const datac = this.base64encode(this.utf16to8(this.trimRight(JSON.stringify(logstatusjson))))
    const RZCIJSON = { rankey: pgeRZRandNum, datab: pgeRZDataB, datac }
    return this.pwdGetData(RZCIJSON)
  }
  this.getVersionAsync = function (callback) {
    //		var datac = getEnStr(pgeRZRandNum,versionjson);
    const datac = this.base64encode(this.utf16to8(this.trimRight(JSON.stringify(versionjson))))
    const RZCIJSON = { rankey: pgeRZRandNum, datab: pgeRZDataB, datac }
    return this.pwdGetDataAsync(RZCIJSON, callback)
  }
  this.getProvList = function () {
    //		var datac = getEnStr(pgeRZRandNum,provlistjson);
    const datac = this.base64encode(this.utf16to8(this.trimRight(JSON.stringify(provlistjson))))
    const RZCIJSON = { rankey: pgeRZRandNum, datab: pgeRZDataB, datac }
    return this.pwdGetData(RZCIJSON)
  }
  this.setLicense = function () {
    //		var datac = getEnStr(pgeRZRandNum,licensejson);
    const datac = this.base64encode(this.utf16to8(this.trimRight(JSON.stringify(licensejson))))
    const RZCIJSON = { rankey: pgeRZRandNum, datab: pgeRZDataB, datac }
    return this.pwdGetData(RZCIJSON)
  }
  this.binayUtf8ToString = function (buf, begin) {
    const i = 0
    let pos = 0
    let str = ''
    let unicode = 0
    let flag = 0
    for (pos = begin; pos < buf.length;) {
      flag = buf[pos]
      if ((flag >>> 7) === 0) {
        str += String.fromCharCode(buf[pos])
        pos += 1
      }
      else if ((flag & 0xFC) === 0xFC) {
        unicode = (buf[pos] & 0x3) << 30
        unicode |= (buf[pos + 1] & 0x3F) << 24
        unicode |= (buf[pos + 2] & 0x3F) << 18
        unicode |= (buf[pos + 3] & 0x3F) << 12
        unicode |= (buf[pos + 4] & 0x3F) << 6
        unicode |= (buf[pos + 5] & 0x3F)
        str += String.fromCharCode(unicode)
        pos += 6
      }
      else if ((flag & 0xF8) === 0xF8) {
        unicode = (buf[pos] & 0x7) << 24
        unicode |= (buf[pos + 1] & 0x3F) << 18
        unicode |= (buf[pos + 2] & 0x3F) << 12
        unicode |= (buf[pos + 3] & 0x3F) << 6
        unicode |= (buf[pos + 4] & 0x3F)
        str += String.fromCharCode(unicode)
        pos += 5
      }
      else if ((flag & 0xF0) === 0xF0) {
        unicode = (buf[pos] & 0xF) << 18
        unicode |= (buf[pos + 1] & 0x3F) << 12
        unicode |= (buf[pos + 2] & 0x3F) << 6
        unicode |= (buf[pos + 3] & 0x3F)
        str += String.fromCharCode(unicode)
        pos += 4
      }
      else if ((flag & 0xE0) === 0xE0) {
        unicode = (buf[pos] & 0x1F) << 12
        unicode |= (buf[pos + 1] & 0x3F) << 6
        unicode |= (buf[pos + 2] & 0x3F)
        str += String.fromCharCode(unicode)
        pos += 3
      }
      else if ((flag & 0xC0) === 0xC0) { // 110
        unicode = (buf[pos] & 0x3F) << 6
        unicode |= (buf[pos + 1] & 0x3F)
        str += String.fromCharCode(unicode)
        pos += 2
      }
      else {
        str += String.fromCharCode(buf[pos])
        pos += 1
      }
    }
    return str
  }
  const base64EncodeChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
  const base64DecodeChars = [
    -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
    -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1,
    -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, 62, -1, -1, -1, 63,
    52, 53, 54, 55, 56, 57, 58, 59, 60, 61, -1, -1, -1, -1, -1, -1,
    -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14,
    15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, -1, -1, -1, -1, -1,
    -1, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40,
    41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, -1, -1, -1, -1, -1]
  this.base64encode = function (str) {
    let out, i, len
    let c1, c2, c3
    len = str.length
    i = 0
    out = ''
    while (i < len) {
      c1 = str.charCodeAt(i++) & 0xFF
      if (i == len) {
        out += base64EncodeChars.charAt(c1 >> 2)
        out += base64EncodeChars.charAt((c1 & 0x3) << 4)
        out += '=='
        break
      }
      c2 = str.charCodeAt(i++)
      if (i == len) {
        out += base64EncodeChars.charAt(c1 >> 2)
        out += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xF0) >> 4))
        out += base64EncodeChars.charAt((c2 & 0xF) << 2)
        out += '='
        break
      }
      c3 = str.charCodeAt(i++)
      out += base64EncodeChars.charAt(c1 >> 2)
      out += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xF0) >> 4))
      out += base64EncodeChars.charAt(((c2 & 0xF) << 2) | ((c3 & 0xC0) >> 6))
      out += base64EncodeChars.charAt(c3 & 0x3F)
    }
    return out
  }
  this.base64decode = function (str) {
    let c1, c2, c3, c4
    let i, len, out
    len = str.length
    i = 0
    out = ''
    while (i < len) {
    /* c1 */
      do
        c1 = base64DecodeChars[str.charCodeAt(i++) & 0xFF]
      while (i < len && c1 == -1)
      if (c1 == -1)
        break
      /* c2 */
      do
        c2 = base64DecodeChars[str.charCodeAt(i++) & 0xFF]
      while (i < len && c2 == -1)
      if (c2 == -1)
        break
      out += String.fromCharCode((c1 << 2) | ((c2 & 0x30) >> 4))
      /* c3 */
      do {
        c3 = str.charCodeAt(i++) & 0xFF
        if (c3 == 61)
          return out
        c3 = base64DecodeChars[c3]
      } while (i < len && c3 == -1)
      if (c3 == -1)
        break
      out += String.fromCharCode(((c2 & 0xF) << 4) | ((c3 & 0x3C) >> 2))
      /* c4 */
      do {
        c4 = str.charCodeAt(i++) & 0xFF
        if (c4 == 61)
          return out
        c4 = base64DecodeChars[c4]
      } while (i < len && c4 == -1)
      if (c4 == -1)
        break
      out += String.fromCharCode(((c3 & 0x03) << 6) | c4)
    }
    return out
  }
  this.base64decodearr = function (str) {
    let c1,
      c2,
      c3,
      c4
    let i,
      len,
      out
    len = str.length
    i = 0
    out = []
    while (i < len) {
      do
        c1 = base64DecodeChars[str.charCodeAt(i++) & 0xFF]
      while (i < len && c1 == -1)
      if (c1 == -1)
        break
      do
        c2 = base64DecodeChars[str.charCodeAt(i++) & 0xFF]
      while (i < len && c2 == -1)
      if (c2 == -1)
        break
      out.push((c1 << 2) | ((c2 & 0x30) >> 4))
      do {
        c3 = str.charCodeAt(i++) & 0xFF
        if (c3 == 61)
          return out
        c3 = base64DecodeChars[c3]
      } while (i < len && c3 == -1)
      if (c3 == -1)
        break
      out.push(((c2 & 0xF) << 4) | ((c3 & 0x3C) >> 2))
      do {
        c4 = str.charCodeAt(i++) & 0xFF
        if (c4 == 61)
          return out
        c4 = base64DecodeChars[c4]
      } while (i < len && c4 == -1)
      if (c4 == -1)
        break
      out.push(((c3 & 0x03) << 6) | c4)
    }
    return out
  }
  this.utf16to8 = function (str) {
    let out, i, len, c
    out = ''
    len = str.length
    for (i = 0; i < len; i++) {
      c = str.charCodeAt(i)
      if ((c >= 0x0001) && (c <= 0x007F)) {
        out += str.charAt(i)
      }
      else if (c > 0x07FF) {
        out += String.fromCharCode(0xE0 | ((c >> 12) & 0x0F))
        out += String.fromCharCode(0x80 | ((c >> 6) & 0x3F))
        out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F))
      }
      else {
        out += String.fromCharCode(0xC0 | ((c >> 6) & 0x1F))
        out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F))
      }
    }
    return out
  }
  this.utf8to16 = function (str) {
    let out, i, len, c
    let char2, char3
    out = ''
    len = str.length
    i = 0
    while (i < len) {
      c = str.charCodeAt(i++)
      switch (c >> 4) {
        case 0: case 1: case 2: case 3: case 4: case 5: case 6: case 7:
        // 0xxxxxxx
          out += str.charAt(i - 1)
          break
        case 12: case 13:
        // 110x xxxx   10xx xxxx
          char2 = str.charCodeAt(i++)
          out += String.fromCharCode(((c & 0x1F) << 6) | (char2 & 0x3F))
          break
        case 14:
        // 1110 xxxx  10xx xxxx  10xx xxxx
          char2 = str.charCodeAt(i++)
          char3 = str.charCodeAt(i++)
          out += String.fromCharCode(((c & 0x0F) << 12)
                       | ((char2 & 0x3F) << 6)
                       | ((char3 & 0x3F) << 0))
          break
      }
    }
    return out
  }
  this.CharToHex = function (str) {
    let out, i, len, c, h
    out = ''
    len = str.length
    i = 0
    while (i < len) {
      c = str.charCodeAt(i++)
      h = c.toString(16)
      if (h.length < 2)
        h = `0${h}`
      out += `\\x${h} `
      if (i > 0 && i % 8 == 0)
        out += '\r\n'
    }
    return out
  }
  this.getTimes = function () {
    return `zxnp${new Date().getTime()}`
  }
}
// init signmessenger
const signObj = new SignMessenger('smObj')
// refresh the plugin array(in W3C Browser)
if (!navigator.userAgent.includes('MSIE'))
  navigator.plugins.refresh()
/**
* js aes 256 encrypt
* @param sKey randomkey
* @param jsonStr
* @return encrypt str
*/
function getEnStr(sKey, jsonStr) {
  const neiKey = [0x11, 0x22, 0x33, 0x44, 0x55, 0x66, 0x77, 0x1A, 0x2A, 0x2B,
    0x2C, 0x2D, 0x2E, 0x2F, 0x3A, 0x3B, 0x11, 0x22, 0x33, 0x44, 0x55,
    0x66, 0x77, 0x1A, 0x2A, 0x2B, 0x2C, 0x2D, 0x2E, 0x2F, 0x3A, 0x3B]
  let fkey = ''; let lx = ''
  for (let i = 0; i < sKey.length; i++) {
    lx = String.fromCharCode(sKey[i].charCodeAt(0) ^ neiKey[i])
    fkey += lx
  }
  const hexKey = CryptoJS.enc.Utf8.parse(fkey)
  const enStr = CryptoJS.AES.encrypt(JSON.stringify(jsonStr), hexKey, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  })
  return enStr.toString()
}
function stringToHex(str) {
  return str.split('').map((c) => {
    return (`0${c.charCodeAt(0).toString(16)}`).slice(-2)
  }).join('')
}
function str2byte(str) {
  return hexToBytes(this.stringToHex(str))
}
function hexToBytes(hex) {
  for (var bytes = [], c = 0; c < hex.length; c += 2)
    bytes.push(parseInt(hex.substr(c, 2), 16))
  return bytes
}
function hexToString(hexStr) {
  const hex = hexStr.toString()
  let str = ''
  for (let i = 0; i < hex.length; i += 2)
    str += String.fromCharCode(parseInt(hex.substr(i, 2), 16))
  return str
}
export { signObj }
